'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _odataFilterBuilder = require('odata-filter-builder');

var _odataFilterBuilder2 = _interopRequireDefault(_odataFilterBuilder);

var _query = require('utilities/query');

var _regulatorAutocomplete = require('./regulator-autocomplete.html');

var _regulatorAutocomplete2 = _interopRequireDefault(_regulatorAutocomplete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _regulatorAutocomplete2.default,
  bindings: {
    isRequired: '<',
    onRegulatorSelected: '&'
  },
  controller: function () {
    function RegulatorAutocomplete(EventEmitter, RegulatorService) {
      'ngInject';

      _classCallCheck(this, RegulatorAutocomplete);

      Object.assign(this, {
        EventEmitter: EventEmitter,
        RegulatorService: RegulatorService
      });
    }

    _createClass(RegulatorAutocomplete, [{
      key: 'searchRegulators',
      value: function searchRegulators(name) {
        return this.RegulatorService.search(_extends({}, this.RegulatorService.getDefaultQuery(), {
          filter: (0, _odataFilterBuilder2.default)().and(function (x) {
            return x.contains('AgentName', name);
          })
        })).then(function (r) {
          return (0, _query.transformODataResponse)(r).Data;
        });
      }
    }, {
      key: 'selectedRegulatorChanged',
      value: function selectedRegulatorChanged(selectedRegulator) {
        this.onRegulatorSelected(this.EventEmitter({
          regulator: selectedRegulator
        }));
      }
    }]);

    return RegulatorAutocomplete;
  }()
};


// WEBPACK FOOTER //
// ./components/app/common/autocomplete/regulator/regulator-autocomplete.component.js